import { render, staticRenderFns } from "./scGPEA_table.vue?vue&type=template&id=f6742e56&"
import script from "./scGPEA_table.vue?vue&type=script&lang=js&"
export * from "./scGPEA_table.vue?vue&type=script&lang=js&"
import style0 from "./scGPEA_table.vue?vue&type=style&index=0&id=f6742e56&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports